import { Serializable, SerializationHelper } from "@/helpers/SerializationHelper";
import {OrderProduct} from "@/model/OrderProduct";
import {RelatedOrder} from "@/model/RelatedOrder";

export class OrderedProduct implements Serializable {
    product: OrderProduct;
    relatedOrders: RelatedOrder[];

    fromJSON(rawObject: any): void {
        SerializationHelper.copyNonExcludedProperties(this, rawObject, []);
    }
}